
<template>
  <v-layout row wrap class="mt-1">
    <v-flex xs12 md6>
      <room-card v-show="!loading.rooms" v-for="room in rooms" :key="room.id" :room-id="room.id" :room-name="room.classname" :room-position="room.position" :room-unit="room.unit" :room-unit-code="room.unitCode" @reloadRooms="getRooms()" />
      <h2 v-if="loading.rooms" class="text-xs-center font-weight-light">CARREGANDO SALAS, AGUARDE!</h2>
      <h2 v-else-if="!rooms.length" class="text-xs-center font-weight-light">NÃO HÁ SALAS PARA MOSTRAR!</h2>
    </v-flex>
    <v-flex xs12 md6>
      <v-form ref="roomForm" class="px-3 elevation-2" v-model="validRoom" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-alert v-model="alert.status" dismissible :type="alert.type">{{ alert.message }}</v-alert>
            <h3 class="mb-2">CADASTRAR NOVA SALA AO SISTEMA.</h3>
            <hr>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-text-field v-model="roomData.name" :counter="46" label="NOME, EX: ZEUS, HÉRCULES, 19º..." :rules="nameRules" required box/>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-text-field v-model="roomData.position" :counter="6" label="POSIÇÃO DA SALA NA LISTAGEM." :rules="positionRules" required box/>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-select box color="black" v-model="roomData.unit" hint="UNIDADE DE ALOCAÇÃO DA SALA." :items="units" item-text="name" item-value="id" persistent-hint return-object single-line required></v-select>
          </v-flex>
          <v-flex xs6 class="mt-0 pt-0">
            <v-btn class="ma-0" color="success" style="width: 100%;" @click="createRoom()" outline>CADASTRAR</v-btn>
          </v-flex>
          <v-flex xs6 class="mt-0 pt-0">
            <v-btn class="ma-0" color="error" style="width: 100%;" @click="clearForm()" outline>LIMPAR</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import RoomCard from '../../components/RoomCard'

export default {
  name: 'rooms',
  components: { RoomCard },
  data() {
    return {
      rooms: [],
      validRoom: true,
      roomData: { name: '', position: '', unit: { name: '', id: '' } },
      units: [],
      loading: {
        rooms: true,
      },
      nameRules: [
        v => !!v || 'NOME REQUERIDO!',
        v => (v && v.length >= 2) || 'NOME NÃO PODE TER MENOS DE 02 CARACTERES!',
        v => (v && v.length <= 46) || 'NOME NÃO PODE TER MAIS DE 46 CARACTERES!',
      ],
      positionRules: [
        v => !!v || 'POSIÇÃO REQUERIDA!',
        v => (v && v.length >= 1) || 'POSIÇÃO NÃO PODE TER MENOS DE 01 CARACTERES!',
        v => (v && v.length <= 6) || 'POSIÇÃO NÃO PODE TER MAIS DE 06 CARACTERES!',
        v => (v && Number.isInteger(Number(v))) || 'O VALOR DEVE SER UM NUMERO!',
      ],
      alert: {
        message: '',
        type: 'success',
        status: false
      }
    }
  },
  methods: {
    getRooms() {
      this.loading.rooms = true
      this.$http.get(`classrooms`).then(data => {
        this.rooms = data.data
        this.getUnits()
        this.loading.rooms = false
      }).catch(err => {
        this.alert.message = err
        this.alert.type = 'error'
        this.alert.status = true
      })
    },
    getUnits() {
      this.$http.get('units').then(data => {
        this.units = data.data
        this.roomData.unit = this.units[0]
      }).catch(err => {
        this.alert.message = err
        this.alert.type = 'error'
        this.alert.status = true
      })
    },
    createRoom() {
      if (this.$refs.roomForm.validate() && this.roomData.unit != undefined) {
        this.$http.post(`classrooms/${this.roomData.unit.id}`, {
          name: this.roomData.name,
          position: this.roomData.position
        }).then(data => {
          this.getRooms()
          this.$refs.roomForm.reset()

          this.alert.message = 'SALA CADASTRADA!'
          this.alert.type = 'success'
          this.alert.status = true
        }).catch(err => {
          this.alert.message = err
          this.alert.type = 'error'
          this.alert.status = true
        })
      } else {
        this.alert.message = 'CAMPOS INVALIDOS!'
        this.alert.type = 'warning'
        this.alert.status = true
      }
    },
    clearForm() {
      this.$refs.roomForm.reset()
    }
  },
  created() {
    this.getRooms()
  }
}
</script>

<style scoped>

</style>
